/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import PrimaryBTN from "../BTN/primaryBTN";
import ComunidadesEstudantes from "../../imgs/ProcessoIntegracao/comunidades_estudantes.jpg";
import SessoesOrientacao from "../../imgs/ProcessoIntegracao/sessoes_orientacao.jpg";
import LUA from "../../imgs/ProcessoIntegracao/lua.jpg";
import { withNamespaces } from 'react-i18next';

const ProcessoIntegracao = ({ t }) => {

  const formatPhoneValues = (phoneNumber) => {
    phoneNumber = phoneNumber.replace(/[^\d]/g, '');
    return `+351 ${phoneNumber.slice(0, 3)} 
  ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6, 9)}`
  }

  return (
    <>
      <div className="container">
        {/* AREA 1 APOIO AO ESTUDANTE INTERNACIONAL */}
        <div id="1" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('moduleProcessoIntegracao:S1.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8">
            <div id="ua_intercultural" className="fantasmaAncora"></div>
            <h3>{t('moduleProcessoIntegracao:S1.ST1.ST')}</h3>
            <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S1.ST1.P1') }}>
            </p>
            <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S1.ST1.P2') }}>
            </p>
            <iframe
              src="https://www.youtube.com/embed/ds6rjLQqeVo"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="next"
              title={t('moduleProcessoIntegracao:S1.ST1.Title')}
            ></iframe>
            <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S1.ST1.P3') }}>
            </p>
            <PrimaryBTN
              alinhar="text-end mb-4"
              link="/chegadaaveiro#3"
              title={t('moduleBotoes:B5.Title.B1')}
              texto={t('moduleBotoes:B5.B')}
            />

            <div id="claim_ua" className="fantasmaAncora"></div>
            <h3 className="">{t('moduleProcessoIntegracao:S1.ST2.ST')}</h3>
            {/* VIDEO */}
            <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S1.ST2.P1') }}>
            </p>
            <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S1.ST2.P2') }}>
            </p>
            <PrimaryBTN
              alinhar="text-end mb-4"
              link="/chegadaaveiro#4"
              title={t('moduleBotoes:B5.Title.B2')}
              texto={t('moduleBotoes:B5.B')}
            />
            <div id="comunidades_estudantes" className="fantasmaAncora"></div>
            <h3>{t('moduleProcessoIntegracao:S1.ST3.ST')}</h3>
            <p className="p_next">
              {t('moduleProcessoIntegracao:S1.ST3.P1')}
            </p>
            <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S1.ST3.P2') }}>
            </p>
            <img
              src={ComunidadesEstudantes}
              alt={t('moduleProcessoIntegracao:S1.ST3.Alt')}
              className="img_only"
            />

            <div id="esn_aveiro" className="fantasmaAncora"></div>
            <h3>{t('moduleProcessoIntegracao:S1.ST4.ST')}</h3>
            <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S1.ST4.P1') }}>
            </p>
            <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S1.ST4.P2') }}>
            </p>
            <iframe
              src="https://www.youtube.com/embed/HQZekdhKwr0"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title={t('moduleProcessoIntegracao:S1.ST4.Title')}
            ></iframe>

            <div id="programa_buddy" className="fantasmaAncora"></div>
            <h3>{t('moduleProcessoIntegracao:S1.ST5.ST')}</h3>
            <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S1.ST5.P1') }}>
            </p>
            <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S1.ST5.P2') }}>
            </p>
            <p>
              {t('moduleProcessoIntegracao:S1.ST5.P3')}
            </p>
          </div>
        </div>
        {/* AREA 2 APOIO PEDAGÓGICO*/}
        <div id="2" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('moduleProcessoIntegracao:S2.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8">
            <div id="curso_nivelamento" className="fantasmaAncora"></div>
            <h3>{t('moduleProcessoIntegracao:S2.ST1.ST')}</h3>
            <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S2.ST1.P1') }}>
            </p>
            <p>
              <span dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S2.ST1.P2') }}>
              </span>
              <a className='link' target='_blank' rel='noreferrer' href={t('moduleProcessoIntegracao:S2.ST1.Link')}>{t('moduleProcessoIntegracao:S2.ST1.Link')}</a>
            </p>

            <div id="gabinete_pedagogico" className="fantasmaAncora"></div>
            <h3>{t('moduleProcessoIntegracao:S2.ST2.ST')}</h3>
            <p dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S2.ST2.P1') }}>
            </p>
          </div>
        </div>
        {/* AREA 3 APOIO ACADÉMICO*/}
        <div id="3" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('moduleProcessoIntegracao:S3.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8">
            <div id="provedor_estudante" className="fantasmaAncora"></div>
            <h3>{t('moduleProcessoIntegracao:S3.ST1.ST')}</h3>
            <p dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S3.ST1.P1') }}>
            </p>
            <div id="programa_tutoria" className="fantasmaAncora"></div>
            <h3>{t('moduleProcessoIntegracao:S3.ST2.ST')}</h3>
            <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S3.ST2.P1') }}>
            </p>
            <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S3.ST2.P2') }}>
            </p>
            <iframe
              src="https://www.youtube.com/embed/KMCqS8XwAWM"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title={t('moduleProcessoIntegracao:S3.ST2.Title')}
            ></iframe>

            <div id="sessoes_orientacao" className="fantasmaAncora"></div>
            <h3>{t('moduleProcessoIntegracao:S3.ST3.ST')}</h3>
            <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S3.ST3.P1') }}>
            </p>
            <p className="p_next">
              {t('moduleProcessoIntegracao:S3.ST3.P2')}
            </p>
            <img
              src={SessoesOrientacao}
              alt={t('moduleProcessoIntegracao:S3.ST3.Alt')}
              className="img_only"
            />

            <div id="diretores_curso_coordenadores_dep" className="fantasmaAncora"></div>
            <h3>{t('moduleProcessoIntegracao:S3.ST4.ST')}</h3>
            <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S3.ST4.P1') }}>
            </p>
            <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S3.ST4.P2') }}>
            </p>
            <p>
              <span dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S3.ST4.P3') }}>
              </span>
              <a target='_blank' rel='noreferrer' className='link text-break' href={t('moduleProcessoIntegracao:S3.ST4.Link.Link1')}>{t('moduleProcessoIntegracao:S3.ST4.Link.Link1')}</a>
              {t('moduleProcessoIntegracao:S3.ST4.Link.P1')}
              <a className='link' target='_blank' rel='noreferrer' href={t('moduleProcessoIntegracao:S3.ST4.Link.Link2')}>{t('moduleProcessoIntegracao:S3.ST4.Link.Link2')}</a>
              {t('moduleProcessoIntegracao:S3.ST4.Link.P2')}
            </p>

            <div id="nucleos_curso" className="fantasmaAncora"></div>
            <h3>{t('moduleProcessoIntegracao:S3.ST5.ST')}</h3>
            <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S3.ST5.P1') }}>
            </p>
            <p dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S3.ST5.P2') }}>
            </p>

            <div id="associacao_academica" className="fantasmaAncora"></div>
            <h3>{t('moduleProcessoIntegracao:S3.ST6.ST')}</h3>
            <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S3.ST6.P1') }}>
            </p>
            <p className="p_next">
              {t('moduleProcessoIntegracao:S3.ST6.P2')}
            </p>
            <p>
              {t('moduleProcessoIntegracao:S3.ST6.P3')}
            </p>
          </div>
        </div>
        {/* AREA 4 APOIO SOCIAL*/}
        <div id="4" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('moduleProcessoIntegracao:S4.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8">
            <div id="lua" className="fantasmaAncora"></div>
            <h3>{t('moduleProcessoIntegracao:S4.ST1.ST')}</h3>
            <img
              src={LUA}
              alt={t('moduleProcessoIntegracao:S4.ST1.Alt')}
              className="img_only_next"
            />
            <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S4.ST1.P1') }}></p>
            <p>
              <span dangerouslySetInnerHTML={{ __html: t('moduleProcessoIntegracao:S4.ST1.P2') }}>
              </span>
              <a className='link' href={"tel:+351" + t('moduleProcessoIntegracao:S4.ST1.Link.P1')}>
                {formatPhoneValues(t('moduleProcessoIntegracao:S4.ST1.Link.P1'))}
              </a>
              {t('moduleProcessoIntegracao:S4.ST1.Link.P2')}
              <a href={t('moduleProcessoIntegracao:S4.ST1.Link.Link')} className='link'>
                {t('moduleProcessoIntegracao:S4.ST1.Link.P3')}
              </a>
              {t('moduleProcessoIntegracao:S4.ST1.Link.P4')}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces()(ProcessoIntegracao);
